import React, { useEffect, useState, useRef } from 'react';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    position: 'absolute',
    inset: 0,
    zIndex: 998,
    height: 6,
    borderRadius: 0,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: "0px",
        backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
    },
    '&.progress-fade': {
        opacity: 0,
    },
}));

const useProgress = (loading) => {
    const [progress, setProgress] = useState(0);
    const [hidden, setHidden] = useState(!loading);
    const timerRef = useRef();

    const updateProgress = () => {
        setProgress((prevProgress) => {
            const newProgress = prevProgress + 10;
            if (newProgress >= 100) {
                clearInterval(timerRef.current);
                setTimeout(() => setHidden(true), 300);
                return 100;
            }
            return newProgress;
        });
    };

    useEffect(() => {
        if (loading) {
            setProgress(0);
            setHidden(false);
            timerRef.current = setInterval(updateProgress, 25);
        } else {
            clearInterval(timerRef.current);
            setHidden(true);
            setProgress(0);
        }
        return () => clearInterval(timerRef.current);
    }, [loading]);

    return { progress, hidden };
};

const ReactProgressBar = ({ loading }) => {
    const { progress, hidden } = useProgress(loading);

    return (
        <Box sx={{ flexGrow: 1 }}>
            <BorderLinearProgress
                style={{ zIndex: "99999" }}
                className={hidden ? 'progress-fade' : ''}
                variant="determinate"
                value={progress}
            />
        </Box>
    );
};

export default ReactProgressBar;
